import { render, staticRenderFns } from "./xlPage.vue?vue&type=template&id=263934b8&scoped=true"
import script from "./xlPage.vue?vue&type=script&lang=js"
export * from "./xlPage.vue?vue&type=script&lang=js"
import style0 from "./xlPage.vue?vue&type=style&index=0&id=263934b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263934b8",
  null
  
)

export default component.exports